import React from 'react';

import {
    PlaylistAddCheck as PedidoEfetivadoIcon,
    AccessTime as CarroFabricadoIcon,
    DirectionsCar as CarroPreparadoIcon,
    LocalShipping as CarroTransporteIcon,
    EmojiEmotions as CarroDisponivelIcon,
    CheckCircleOutline as CarroUtilizacaoIcon
} from '@material-ui/icons';

import { StatusPedidoEnum } from '../enums';

function IconeStatusPedido(
    {
        codigoStatus,
        ...props
    }
) {
    const icone = {
        [StatusPedidoEnum.EFETIVADO]: <PedidoEfetivadoIcon {...props} />,
        [StatusPedidoEnum.FABRICADO]: <CarroFabricadoIcon {...props} />,
        [StatusPedidoEnum.PREPARADO]: <CarroPreparadoIcon {...props} />,
        [StatusPedidoEnum.TRANSPORTE]: <CarroTransporteIcon {...props} />,
        [StatusPedidoEnum.DISPONIVEL]: <CarroDisponivelIcon {...props} />,
        [StatusPedidoEnum.UTILIZACAO]: <CarroUtilizacaoIcon {...props} />
    }

    return (icone[codigoStatus]);
}

export default IconeStatusPedido;